import React from "react";
import Button from "../../../../form/Button";
import useMutation from "../../../../../hooks/useMutation";
import { scholarShipApply } from "../../../../../services/applicationFormService";
import { toast } from "react-toastify";

const WarningsFront = ({
  close = () => {},
  continueHandler = () => {},
  data,
  details,
  scholarshipId,
  setLoaded = () => {},
}) => {
  const labelHtml = data?.data?.[0]?.label ?? "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(labelHtml, "text/html");
  const strongText = doc.querySelector("strong")?.innerHTML;
  const fullText = doc.body.textContent || "";

  const remainingText = fullText.replace(strongText, "").trim();

  const { mutate, error, isLoading } = useMutation({
    mutationFn: async (val) => {
      setLoaded(true);
      const structuredData = data?.data?.map((field) => ({
        fieldId: field._id || field.id,
        label: field?.label,
        value: field?.label,
      }));
      return await scholarShipApply({
        groupCodeData: structuredData,
        scholarshipId: scholarshipId,
        groupCode: data?._id,
        formId: details?.applicationFormId,
      });
    },
    onSuccess: (res) => {
      setLoaded(false);
      if (res?.isFormSubmitted) {
        close();
      } else {
        continueHandler();
      }
    },
    onError: (error) => {
      toast.error("Submission failed");
      setLoaded(false);
    },
  });

  return (
    <>
      <div className="text-center font-normal text-base max-w-2xl mx-auto !leading-loose">
        {strongText && <span className="font-semibold">{strongText}</span>}
        {remainingText && <p>{remainingText}</p>}
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonLabel={"Start"}
            buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            buttonLabelClasses="mx-auto"
            buttonFunction={() => mutate()}
          />
          <Button
            buttonLabel={"Exit"}
            buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            buttonLabelClasses="mx-auto"
            buttonFunction={close}
          />
        </div>
      </div>
    </>
  );
};

export default WarningsFront;
